require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-gladimdim-bs-semver.json") })
        }
      }, "path---package-gladimdim-bs-semver");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-gladimdim-bs-semver!./.cache/json/package-gladimdim-bs-semver.json
// module id = 862
// module chunks = 231608221292675